import { Business, Close } from "@mui/icons-material";
import { Avatar, Backdrop, Box, Grid, IconButton, Typography } from "@mui/material";
import { useCallback, useMemo } from "react";
import { useLanguageContext } from "../../contexts/LanguageContext";
import { useNavigationContext } from "../../contexts/NavigationContext";
import { useUserContext } from "../../contexts/UserContext";
import { StartLink } from "../../data/Navigation";
import DateTimeHelper from "../../helpers/DateTimeHelper";
import StringHelper from "../../helpers/StringHelper";
import IEnterprise from "../../interfaces/IEnterprise";
import { IDialogProps } from "../Dialog";


const ChangeEnterpriseDialog: React.FunctionComponent<Pick<IDialogProps, 'open' | 'handleClose'>> = ({ open, handleClose }) => {
    const { translate } = useLanguageContext();
    const { setSelectedNavigationLink } = useNavigationContext();
    const { user, enterprise, handleChangeEnterprise } = useUserContext();

    
    const _handleChangeEnterprise = useCallback((enterprise: IEnterprise) => {
        setSelectedNavigationLink(StartLink);
        handleChangeEnterprise(enterprise);
        handleClose();
        // eslint-disable-next-line
    }, []);


    const enterprises = useMemo(() => {
        return user?.enterprises.map(e => {
            const illustration = e.illustration.split('?')[0];
            const randomText = StringHelper.RandomText(12, false, true, true, false);

            let className = '';
            let handleClick = () => _handleChangeEnterprise(e as IEnterprise);


            // Create subtitle with expires date
            let subtitle = undefined;

            const date = DateTimeHelper.Format(`${e.expiresAt}T23:59:59`);
            const diff = DateTimeHelper.Diff(`${e.expiresAt}T23:59:59`, DateTimeHelper.Now());
            
            if (diff < 0) {
                className = 'disabled';
                handleClick = () => {};

                subtitle = <Typography variant='subtitle1' component='h6' className='text-subtitle color-red'>
                    {translate('expiredAt')} {date}
                </Typography>;
            } else {
                const defaultLabel = `${translate('expiresAt')} ${date}`;

                if (diff < 5) {
                    let sulfix = diff === 0 ? 'today' : (diff === 1 ? 'tomorrow' : 'days');
                    sulfix = translate(sulfix).toLowerCase();

                    if (diff > 1) {
                        sulfix = `${diff} ${sulfix}`;
                    }

                    subtitle = <Typography variant='subtitle1' component='h6' className='text-subtitle color-amber'>
                        {defaultLabel} ({sulfix})
                    </Typography>;
                } else {
                    subtitle = <Typography variant='subtitle1' component='h6' className='text-subtitle'>
                        {defaultLabel}
                    </Typography>;
                }
            }

            return <Box className={`box-enterprise ${className}`} onClick={handleClick} key={e.id}>
                <Avatar 
                    className='avatar-enterprise' 
                    src={`${illustration}?uniq=${randomText}`}
                >
                    <Business fontSize='large' />
                </Avatar>

                <Grid item className='grid-informations'>
                    <Typography variant='subtitle1' component='h6' className='text-title'>{e.name}</Typography>
                    {subtitle}
                </Grid>
            </Box>;
        });
        
        // eslint-disable-next-line
    }, [translate]);


    return (
        <Backdrop open={!enterprise || open} className='backdrop-changeenterprise'>
            {
                enterprise && (
                    <IconButton className='button-close-trigger' onClick={handleClose}>
                        <Close />
                    </IconButton>
                )
            }

            <Grid container className='grid-container'>
                {enterprises}
            </Grid>
        </Backdrop>
    );
}

export default ChangeEnterpriseDialog;